module.exports = __webpack_public_path__ + "static/media/Contacts.bb41f017.jpeg";